const INITIAL_STATE = {
    multas: [],
    multa: null
  }
  
  export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case 'MULTAS_FETCH':
        return { ...state, multas: action.payload }
      case 'MULTA_FETCH':
        return { ...state, multa: action.payload }
      default:
        return state
    }
  }